import { IUserStorageTableConfiguration } from "./types"

export enum UserStorageKey {
    inventoryAssetListViewTableColumnsConfiguration = "inventoryAssetListViewTableColumnsConfiguration",
    schedulerTableColumnsConfiguration = "schedulerTableColumnsConfiguration",
    assetSidebarPinnedFields = "assetSidebarPinnedFields",
    reservationSidebarPinnedFields = "reservationSidebarPinnedFields",
}

// Cannot be decreased, only increased!
// Increase in case if the changes in the structure of IUserStorageTableConfiguration
// that are uncapable with the current version and implement migration logic
export const UserStorageTableConfigurationVersion = 1

export const defaultUserStorageTableConfiguration: IUserStorageTableConfiguration = {
    presets: [],
    currentPresetName: null,
    customView: null,
    version: UserStorageTableConfigurationVersion,
}
